import { Component, OnInit, AfterViewInit, HostListener, ElementRef, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import { RequestServices } from '../services/request.service';
import { Configuration } from '../Constants/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { Prospecto } from "../modelos/prospecto.model";
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService, dataStorage } from '../services/storage.service';
import { DatosCotizacion } from '../modelos/datos-cotizacion.model';
import { StorageEnum } from '../utilities/storage.enum';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { LogConsumo, LogConsumoFunciones } from '../utilities/logConsumo';
import { MatDialog } from '@angular/material/dialog';
import { CotizacionAyudaComponent } from '../cotizacion/ayuda/cotizacion-ayuda.component';
import { CotizacionRenovacionComponent } from '../cotizacion/renovacion/cotizacion-ayuda.component';

import { FormControl, Validators } from '@angular/forms';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';


declare var gtag;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit, AfterViewInit {
  public const: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public loader: boolean = false;
  public logConsumoId: string = "";
  prospecto: Prospecto = new Prospecto();
  public correo = new FormControl(this.prospecto.correo, Validators.required);
  public logConsumoData: LogConsumo = new LogConsumo();
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  public openCot: boolean = false;
  public telefono: string = "";
  public celular: string = "";
  public sexo: number = 1;
  public edad: string = "18";

  validacionCorreo: number = 40;
  datosCotizacion: DatosCotizacion = {
    multicotiza: {
      f1: new Configuration().MULTINEGOCIO_ID,
      f2: 29,
      f3: '',
      f4: (new Date().getFullYear()),
      f5: 1,
      f7: 0,
      f8: '',
      f9: ''
    },
    datosAuto: {
      paquete: 0,
      logoMarca: '',
      descripcion: ''
    }
  };
  aseguradoraId: number = 29;
  tipoVehiculoBuscador: number = 10;
  private observableStorage: any;
  // tipoAuto: number = 0;
  // tipoUnidad: number = 0;
  modelos: any[] = [];
  marcas: any[] = [];
  descripciones: any[] = [];
  tipos: any[] = [];
  public isVisibleProteccionAdicional: boolean = true;
  mostrarPopUp: boolean = true;
  correoValido:boolean = true;
  numeroValido: boolean = true;
  public fuente: string = "";
  public camapania: string = "";
  public medio: string = "";
  public contenido: string = "";

  isMobile: boolean = false;
  @ViewChild('servicios', {static: false}) productPanel: ElementRef;
  @ViewChild('cotizador', {static: false}) quotePanel: ElementRef;
  @ViewChild('beneficios', {static: false}) benefitsPanel: ElementRef;
  @ViewChild("popExplorer") popExplorer: any;
  isPremier: boolean;
  isUpSivale: boolean;
  cpInvalid: boolean;
  nombreInvalid: boolean;
  isInterMX: boolean;
  constructor(private router: Router, private requestService: RequestServices, private snackBar: MatSnackBar, private storageService: StorageService, private modal: MatDialog, private route: ActivatedRoute) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }


  }

  public addItem(event){
    switch (event) {
      case 'servicios':
        this.localizaPanel(this.productPanel, 0);
        break;
      case 'cotizador':
        this.localizaPanel(this.quotePanel, 0);
        break;
      case 'beneficios':
        this.localizaPanel(this.benefitsPanel, 0);
        break;
    }
  }

  getImage() {

    if(this.isMobile && this.isPremier || this.isUpSivale) {

      return 'Url(../../assets/images/premier/fondoPremier.png)';
    }else if(this.isMobile) { 
      return this.styleCocheSeguro.srcBanner;
    } else {

      return this.styleCocheSeguro.srcBanner;
    }
  }

  getCover = () => this.isMobile ? '' : 'cover';

  localizaPanel(panel: ElementRef, subtract: number){
    window.scrollBy({
      top: panel?.nativeElement.getBoundingClientRect().top - subtract,
      left: 0,
      behavior: 'smooth'
    });
  }

  ngAfterViewInit(): void {
    try {
      this.correo.valueChanges
        .subscribe((text: string) => {
          text = text.toLowerCase();
          this.prospecto.correo = text.toLowerCase();
          if (!text.match("[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9]){1,}")) {
            this.correo.setErrors({ invalid: true });
          }
        });
    } catch (error) {
      this.snackBar.open("InicioComponent.ngAfterViewInit().error", error, { duration: this.const.SNACK_BARTIME });
    }
      if(this.navegador() === true){
        this.popup();
      }
  }

  ngOnDestroy(): void {
    try {
      this.observableStorage?.complete();
      this.observableStorage?.unsubscribe();
    } catch (error) {
      this.snackBar.open("InicioComponent.ngOnDestroy().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }


  ngOnInit() {


    this.storageService.removeItem(44);
    this.isInterMX = (window.location.hostname === 'cocheseguro.inter.mx' || window.location.hostname === 'localhost') ? true : false;

    this.route.queryParams.subscribe(result => {
      if (result.utm_source) {
        this.fuente = result.utm_source;
      }
      if (result.utm_campaign) {
        this.camapania = result.utm_campaign;
      }
      if (result.utm_medium) {
        this.medio = result.utm_medium;
      }
      if (result.utm_content) {
        this.contenido = result.utm_content;
      }

      if(result.codp) {
        this.storageService.setItem('codp', result.codp);
      }
    });

    this.isPremier = (window.location.hostname == 'cocheseguroclubpremier.inter.mx') ? true : false;
    this.isUpSivale = (window.location.hostname == 'cochesegurosivale.inter.mx') ? true : false;

    gtag({ 'event': 'formStep0View' });

    this.isMobile = (window.innerWidth < 1025)? true : false;

    let fecha: Date = new Date();
    let modelo: number = (fecha.getFullYear() + 1);
    for (let i = 0; i <= (modelo - 2000); i++) {
      this.modelos.push({ "c1": (fecha.getFullYear() + 1) });
      fecha.setFullYear(fecha.getFullYear() - 1);
    }
    /**Se llenó select de modelos */

    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      if (cocheSeguro.conductor) delete cocheSeguro['conductor'];
      if (cocheSeguro.dataVehiculo) delete cocheSeguro['dataVehiculo'];
      if (cocheSeguro.vehiculo) delete cocheSeguro['vehiculo'];
      if (cocheSeguro.cia) delete cocheSeguro['cia'];
      if (cocheSeguro.cot_id) delete cocheSeguro['cot_id'];
      if (cocheSeguro.paquete) delete cocheSeguro['paquete'];
      this.isVisibleProteccionAdicional = cocheSeguro.isVisibleProteccionAdicional;

      this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
      this.storageService.removeItem("cardnumber");
      this.storageService.removeItem("negId");
      this.storageService.removeItem("cardtype");
      this.storageService.removeItem("cotizaciones");

    }

    if (cocheSeguro?.prospecto) {
      this.prospecto = cocheSeguro.prospecto;
      this.correo = new FormControl(this.prospecto.correo, Validators.required);
      if (cocheSeguro.telefono && cocheSeguro.telefono != '') {
        this.telefono = cocheSeguro.telefono;
      }
      if (cocheSeguro.celular && cocheSeguro.celular != '') {
        this.celular = cocheSeguro.celular;
      }
      this.validaCodigoPostal(this.prospecto.cp);
    }

    if (cocheSeguro.edad) {
      this.edad = String(cocheSeguro.edad);
    }

    if (cocheSeguro.sexo != undefined) {
      this.sexo = (cocheSeguro.sexo ? 1 : 0)
    }
    this.getMarcas();
    /**Verificar storage */
    setTimeout(() => {

      //this.modal.open(PopUpComponent, { panelClass: 'myapp-no-padding-dialog' });

      this.observableStorage = this.storageService.watchSessionStorage().subscribe((data: dataStorage) => {
        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) {
          cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        switch (data.accion) {
          case StorageEnum.add: case StorageEnum.update:
            if (data.key == "prospecto") {
              this.prospecto = cocheSeguro.prospecto;
              this.validaCodigoPostal(this.prospecto.cp);
              this.correo = new FormControl(this.prospecto.correo, Validators.required);
            }
            break;
          case StorageEnum.removeAll:
            if (!cocheSeguro?.prospecto || cocheSeguro?.m !== "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8=") {
              this.prospecto = new Prospecto();
              this.prospecto.logeado = false;
              this.telefono = cocheSeguro.telefono;
              this.celular = cocheSeguro.celular;
              this.correo = new FormControl(this.prospecto.correo, Validators.required);
            }
            break;
        }
      });
    }, 500);

  }




    @HostListener('window:resize', ['$event'])
    onResize(event){
      if(window.innerWidth < 1025){
        this.isMobile = true;

      }else{
        this.isMobile = false;
      }
    }


  next() {

    try {
      setTimeout(() => {
        if ((this.prospecto.nombre != "" && this.prospecto.nombre !== '*Ingresa un nombre') && this.prospecto.estado != "" && this.prospecto.cp.length > 4 && !this.correo.hasError('invalid') && this.correoValido && this.correo.value.length > 0 && !this.cpInvalid && this.celular.length === 10) {
          let cocheSeguro: CocheSeguro = new CocheSeguro();


          if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
          }
          cocheSeguro.prospecto = this.prospecto;
          cocheSeguro.edad = parseInt(this.edad);
          cocheSeguro.sexo = (this.sexo == 1);
          cocheSeguro.prospecto.sexo = this.sexo;
          cocheSeguro.urlVerWeb = window.location.protocol + '//' + window.location.host + '/';
          this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
          // this.router.navigate(['datos-vehiculo']);
          if (this.datosCotizacion.multicotiza.f3 == "") {
            this.snackBar.open("Selecciona un auto.", "", { duration: this.const.SNACK_BARTIME });
          } else {
            if (this.storageService.ifExist("logConsumoId")) {
              if(this.datosCotizacion.datosAuto?.tipoUnidad == undefined){
                this.datosCotizacion.datosAuto.tipoUnidad = 0;
              }
              cocheSeguro.dataVehiculo = this.datosCotizacion;
              if (cocheSeguro.telefono && cocheSeguro.telefono != '') {
                cocheSeguro.telefono = this.telefono;
              } else {
                cocheSeguro.telefono = this.celular;
              }
              cocheSeguro.celular = this.celular;
              this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
              setTimeout(() => {
                /* this.updatelogConsumo(); */
                gtag({ 'event': 'formStep0Submit' });
                gtag({
                  'event': 'completeRegistration',
                  'em': this.correo.value.toLocaleLowerCase().trim().replace(/\s/g, ''),
                  'fn': this.prospecto.nombre.toLocaleLowerCase().trim().replace(/\s/g, ''),
                  'zp': isNaN(parseInt(this.prospecto.cp)) ? this.prospecto.cp : parseInt(this.prospecto.cp),
                  'ph': isNaN(parseInt(this.celular)) ? this.celular : parseInt(this.celular),
                  'ge': this.sexo == 1 ? 'm' : 'f'
                }
                );
                if (this.const.PLATFORM) {
                  window.location.href = this.const.URLPLATFORM + 'cotizacion';
                } else {
                  this.router.navigate(['cotizacion']);
                }
              }, 400);

            } else {
              if(this.datosCotizacion.datosAuto?.tipoUnidad == undefined){
                this.datosCotizacion.datosAuto.tipoUnidad = 0;
              }
              this.guardarRegistro(this.prospecto, this.datosCotizacion.multicotiza.f4, this.datosCotizacion.multicotiza.f3, this.datosCotizacion.datosAuto.descripcion, 1, this.datosCotizacion.datosAuto.tipoUnidad);
              setTimeout(() => {
                if (this.openCot == true) {
                  cocheSeguro.dataVehiculo = this.datosCotizacion;
                  if (cocheSeguro.telefono && cocheSeguro.telefono != '') {
                    cocheSeguro.telefono = this.telefono;
                  } else {
                    cocheSeguro.telefono = this.celular;
                  }
                  cocheSeguro.celular = this.celular;
                  this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
                  /* this.updatelogConsumo(); */
                  gtag({ 'event': 'formStep0Submit' });
                  gtag({
                    'event': 'completeRegistration',
                    'em': this.correo.value.toLocaleLowerCase().trim().replace(/\s/g, ''),
                    'fn': this.prospecto.nombre.toLocaleLowerCase().trim().replace(/\s/g, ''),
                    'zp': isNaN(parseInt(this.prospecto.cp)) ? this.prospecto.cp : parseInt(this.prospecto.cp),
                    'ph': isNaN(parseInt(this.celular)) ? this.celular : parseInt(this.celular),
                    'ge': this.sexo == 1 ? 'm' : 'f'
                  });
                  if (this.const.PLATFORM) {
                    window.location.href = this.const.URLPLATFORM + 'cotizacion';
                  } else {
                    this.router.navigate(['cotizacion']);
                  }
                }
              }, 1000);
            }
          }
        } else {

          if(this.cpInvalid) {
            this.cpInvalid = true;
            this.prospecto.cp = "*CP no valido";
          }

          if(this.prospecto.nombre === "") {
            this.nombreInvalid = true;
            this.prospecto.nombre = "*Ingresa un nombre";
          }

          if(this.celular.length < 10) {
            this.celular = '*Ingrese un numero valido';
            this.numeroValido = false;
          }

          if ((this.prospecto.estado == "" || this.prospecto.cp.length < 4) && (this.correo.hasError('invalid') || !this.correoValido || this.correo.value.length == 0)) {
            this.correo.setValue('*Ingrese un correo valido');
            this.correoValido = false;
            this.cpInvalid = true;
            this.prospecto.cp = "*CP no valido";
          }
          else if ((this.prospecto.estado == "" || this.prospecto.cp.length < 4) && !this.correo.hasError('invalid') && this.correoValido) {
            this.cpInvalid = true;
            this.prospecto.cp = "*CP no valido";
          } else if ((this.prospecto.estado != "" || this.prospecto.cp.length > 4) && (this.correo.hasError('invalid') || this.correo.value.length == 0 || !this.correoValido)) {
            this.correo.setValue('*Ingrese un correo valido');
            this.correoValido = false;
          }
        }
      }, 300);
    } catch (error) {
      console.log("next().error", error);
    }
  }

  focusCP(e) {

    if(this.cpInvalid) {
      this.cpInvalid = false;
      this.prospecto.cp = "";
    }
  }

  focusEmail(e) {
    if(!this.correoValido){
    this.correoValido = true;
    this.correo.setValue("");
  }

}

  focusNombre(e) {
    if(this.prospecto.nombre){
      this.nombreInvalid = false;
      this.prospecto.nombre = "";
    }
  }

  focusPhoneNumber(e) {
   if(!this.numeroValido){
     this.numeroValido = true;
     this.celular = "";
   }
  }
   keyPressSoloNumeros(event: KeyboardEvent) {

    if (
      event?.key == '0' ||
      event?.key == '1' ||
      event?.key == '2' ||
      event?.key == '3' ||
      event?.key == '4' ||
      event?.key == '5' ||
      event?.key == '6' ||
      event?.key == '7' ||
      event?.key == '8' ||
      event?.key == '9' ||
      event?.key == '.' ||
      event?.keyCode == 48 ||
      event?.keyCode == 49 ||
      event?.keyCode == 50 ||
      event?.keyCode == 51 ||
      event?.keyCode == 52 ||
      event?.keyCode == 53 ||
      event?.keyCode == 54 ||
      event?.keyCode == 55 ||
      event?.keyCode == 56 ||
      event?.keyCode == 57 ||
      event?.keyCode == 46
    ) {
        (<HTMLInputElement>event.target).value =
          (<HTMLInputElement>event.target).value;

    } else {
      event.preventDefault();
    }
  }


  validaCodigoPostal(_cp: any) {
    try {
      this.prospecto.cp = _cp;
        try {
          this.requestService.getRequest({ projectName: new Configuration().URLDATATRANSFER, apiName: 'CodigoPostalvalidacionAPI', params: [{ f1: this.prospecto.cp }] }).subscribe(
            result => {
              if (result.error) {
                console.error("error: ", result.error)
              } else {
                if (result.length == 0) {
                  this.cpInvalid = true;
                  this.prospecto.cp = "*CP no valido";
                } else {
                  this.cpInvalid = false;
                  this.prospecto.estado = result[0].c1;
                  this.prospecto.municipio = result[0].c2;
                }
              }
            }, error => {
              console.error("error: ", error);
              this.prospecto.estado = "";
              this.prospecto.municipio = "";
              this.cpInvalid = true;
              this.prospecto.cp = "*CP no valido";
            }
          );
        } catch (e) {
          console.error("Exception ex =>", e);
        }



      if (_cp.length < 5) {
        this.prospecto.estado = "";
        this.prospecto.municipio = "";
    }

    } catch (error) {
      this.snackBar.open("InicioComponent.validaCodigoPostal().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  reiniciaAmis(event) {
    try {
      this.datosCotizacion.multicotiza.f3 = "";
      // this.tipoAuto = 0;
      // this.tipoUnidad = 0;
    } catch (error) {
      this.snackBar.open("InicioComponent.reiniciaAmis().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  //Captura tipo de unidad en Desktop
  autosSalida(event) {
    this.datosCotizacion.multicotiza.f3 = event.c1.c1;
    this.datosCotizacion.multicotiza.f4 = event.c1.c5;
    this.datosCotizacion.datosAuto.logoMarca = event.c1.c6;
    this.datosCotizacion.datosAuto.descripcion = event.c1.c3;
    this.datosCotizacion.datosAuto.marca = event.c1.c4;
    this.datosCotizacion.datosAuto.tipoUnidad = event.c1.c9;
    //console.log('inicio autosalida: ', event.c1.c9)
    this.datosCotizacion.multicotiza.f7 = event.c1.c9;
    //if (event.c8) {
    //this.datosCotizacion.multicotiza.f7 = event.c8 == 2 ? 1 : 0;
    //}
  }

  guardarRegistro(dataLog, modelo: number, amis: string, descripcion: string, tipo: number, tipoUnidad: number) {
    try {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      this.logConsumoData.v1 = "94c3qaBTlOBbdUWPBkxEmg==";//INTERAUTOS ES PRODUCTO_ID 1
      this.logConsumoData.v2 = dataLog.correo; //correo
      this.logConsumoData.v3 = dataLog.nombre; //
      this.logConsumoData.v4 = dataLog.cp;
      this.logConsumoData.v5 = modelo;
      this.logConsumoData.v6 = amis;
      this.logConsumoData.v7 = descripcion;
      this.logConsumoData.v8 = "Amplia"; //ACTUALMENTE SE QUEDARA FIJA, paquete
      this.logConsumoData.v9 = (cocheSeguro?.origen) ? cocheSeguro.origen : 0; //Origen modificarse
      this.logConsumoData.v10 = (this.storageService.ifExist("ayuda")) ? 0 : 1;
      this.logConsumoData.v11 = this.fuente;
      this.logConsumoData.v12 = this.camapania;
      this.logConsumoData.v13 = this.contenido;
      this.logConsumoData.v14 = this.medio;
      this.logConsumoData.v15 = (tipoUnidad != undefined || tipoUnidad != null)? tipoUnidad+"" : "0";
      if (this.logConsumoData.v15 === 'undefined'){
        this.logConsumoData.v15 = '0';
      }

      this.logConsumoFun.logConsumo(this.logConsumoData);
      this.openCot = true;
    } catch (error) {
      this.snackBar.open("InicioComponent.guardarRegistro().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  updatelogConsumo() {
    try {
      let logCon = this.logConsumoFun.logConsumo(this.logConsumoData);
    } catch (error) {
      this.snackBar.open("InicioComponent.updatelogConsumo().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  guardarRegistroInicioAyuda() {
        this.openModalMarcame();
      }

  openModalMarcame() {
    try {
      let modalAyuda = this.modal.open(CotizacionAyudaComponent, { disableClose: false });
      //modalAyuda.afterClosed().subscribe(result => {
      //});
    } catch (error) {
      this.snackBar.open("InicioComponent.openModalMarcame().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  openWin(caso) {
    try {
      switch (caso) {
        case 1:
          window.open("https://productos.inter.mx/bien-seguro");
          break;
        case 2:
          window.open("https://medicoseguro.inter.mx/");
          break;
        case 3:
          window.open("https://mascotasegura.inter.mx/seguro-mascota/landing");
          break;
        case 4:
          window.open("https://vigo.inter.mx/landing");
          break;
        case 5:
          window.open("https://productos.inter.mx/vida-segura/");
          break;
      }
    } catch (error) {
      this.snackBar.open("InicioComponent.openWin().error", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  public cpMask: any = {
    mask: [
      {
        mask: '00000',
        regex: '^[0-9]{5}$'
      }
    ]
  };

  public telefonoMask: any = {
    mask: [
      {
        mask: '0000000000',
        regex: '^[0-9]{10}$'
        //regex: '^(?: (?: \ +? 1 \ s * (?: [.-] \ s *)?)? (? : (\ s * ([2-9] 1 [02-9] | [2-9] [02-8] 1 | [2-9] [02-8] [02-9]) \ s *) | ([2-9] 1 [02-9] | [2-9] [02-8] 1 | [2-9] [02-8] [02-9])) \ s * (?: [ .-] \ s *)?)? ([2-9] 1 [02-9] | [2-9] [02-9] 1 | [2-9] [02-9] {2}) \ s * (?: [.-] \ s *)? ([0-9] {4}) $'
      }
    ]
  };

  public edadMask: any = {
    mask: [
      {
        mask: '00',
        regex: '^[0-9]{2}$'
      }
    ]
  };

  cambioModelo() {
    this.datosCotizacion.multicotiza.f3 = '';
  }

  verificaMarca() {
    this.getTipos();
  }

  getTipos() {
    //this.tipos = [{c1:"94c3qaBTlOBbdUWPBkxEmg==", c2:"tipo0"}, {c1:"f917Va5WwTC+2N4o3l4+BA==", c2:"tipo1"}, {c1:"Iq11nyEuKhO2atPO7zevuw==", c2:"tipo2"}, {c1:"", c2:"tipo3"}, {c1:"EqCZqGFttusLNojjyxsIBQ==", c2:"tipo4"}, {c1:"DkxlYDgr8ppqraux+geoWQ==", c2:"tipo5"}];
    this.loader = true;
    try {
      this.requestService.getRequest({ projectName: /*"http://localhost:8080/data-transfer-api/"*/ new Configuration().URLDATATRANSFER, apiName: 'TiposListadoAPI', params: [{ f1: this.datosCotizacion.multicotiza.f7 }, { f2: this.datosCotizacion.multicotiza.f4 }, { f3: this.datosCotizacion.multicotiza.f8 }, { fc: 29 }] }).subscribe(
        result => {
          this.loader = false;
          if (result.length == 0) {
            this.snackBar.open("Hubo un problema durante el proceso.", "", { duration: 1000 });
            //console.error("Something was wrong => ", result);
            this.resetValores();
          } else {
            this.tipos = result;
            this.descripciones = [];
            this.datosCotizacion.multicotiza.f9 = '';
            this.datosCotizacion.multicotiza.f3 = '';
          }
        }, error => {
          this.loader = false;
          this.resetValores();
          console.error("Error: ", error);
        }
      );
    } catch (e) {
      this.loader = false;
      this.resetValores();
      console.error("Exception ex =>", e);
    }
  }

  verificaModelo(modelo) {
    this.datosCotizacion.multicotiza.f8 = '';
    this.datosCotizacion.multicotiza.f9 = '';
    this.datosCotizacion.multicotiza.f3 = '';
    this.getMarcas();
  }

  getMarcas() {
    this.loader = true;
    try {
      this.requestService.getRequest({ projectName: /*"http://localhost:8080/data-transfer-api/"*/ new Configuration().URLDATATRANSFER, apiName: 'MarcasListadoAPI', params: [{ f1: this.datosCotizacion.multicotiza.f7 }, { f2: this.datosCotizacion.multicotiza.f4 }, { fc: 29 }] }).subscribe(
        result => {
          this.loader = false;
          if (result.length == 0) {
            this.snackBar.open("No se encontraron marcas para este modelo.", "", { duration: new Configuration().SNACK_BARTIME });
            //console.error("Something was wrong => ", result);
            this.resetValores();
          } else {
            this.marcas = result;
            this.marcas.forEach((element, index) => {
              // switch (element.c1.toString().trim().toUpperCase()) {
              //   case 'AR':
              //   case 'AT':
              //   case 'BY':
              //   case 'EQ':
              //   case 'FI':
              //   case 'JR':
              //   case 'LI':
              //   case 'MT':
              //   case 'ML':
              //   case 'MC':
              //   case 'M35':
              //   case 'NO':
              //   case 'PE':
              //   case 'RI':
              //   case 'TE':
              //   case 'VM':
              //   case 'MO':
              //   case 'YH':
              //   case 'M1':
              //   case 'M2':
              //   case 'M3':
              //   case 'M4':
              //   case 'M5':
              //   case 'M6':
              //   case 'M7':
              //   case 'M8':
              //   case 'M9':
              //   case 'M10':
              //   case 'M11':
              //   case 'M12':
              //   case 'M13':
              //   case 'M14':
              //   case 'M15':
              //   case 'M16':
              //   case 'M17':
              //   case 'M18':
              //   case 'M19':
              //   case 'M20':
              //   case 'M21':
              //   case 'M22':
              //   case 'M23':
              //   case 'M24':
              //   case 'M25':
              //   case 'M26':
              //   case 'M27':
              //   case 'M28':
              //   case 'M29':
              //   case 'M30':
              //   case 'M31':
              //   case 'M32':
              //   case 'M33':
              //   case 'M34':
              //   case 'M35':
              //   case 'M36':
              //   case 'M37':
              //   case 'M38':
              //   case 'M39':
              //   case 'M41':
              //   case 'M42':
              //   case 'M43':
              //   case 'M44':
              //   case 'M45':
              //   case 'M46':
              //   case 'M47':
              //   case 'M48':
              //   case 'M49':
              //   case 'M50':
              //   case 'M51':
              //   case 'M52':
              //   case 'M53':
              //   case 'M54':
              //   case 'M55':
              //   case 'MM':
              //   case 'YH':
              //     this.marcas[index]['valid'] = true;
              //     break;
              // }
            });
            this.marcas = this.marcas.filter(item => item.valid === undefined);
            this.tipos = [];
            this.descripciones = [];
            this.datosCotizacion.multicotiza.f9 = '';
            this.datosCotizacion.multicotiza.f3 = '';
          }
        }, error => {
          this.loader = false;
          this.resetValores();
          console.error("Error: ", error);
        }
      );
    } catch (e) {
      this.loader = false;
      this.resetValores();
      console.error("Exception ex =>", e);
    }
  }

  resetValores() {
    if (this.marcas.length > 0) {
      this.marcas = [];
      this.datosCotizacion.multicotiza.f8 = '';
    }

    if (this.tipos.length > 0) {
      this.tipos = [];
      this.datosCotizacion.multicotiza.f9 = '';
    }

    if (this.descripciones.length > 0) {
      this.descripciones = [];
      this.datosCotizacion.multicotiza.f3 = '';
    }
  }

  verificaTipo(tipo) {
    this.getDescripciones();
  }

  getDescripciones() {
    this.loader = true;
    try {
      this.requestService.getRequest({ projectName: /*"http://localhost:8080/data-transfer-api/"*/ new Configuration().URLDATATRANSFER, apiName: 'DescripcionListadoAPI', params: [{ f1: this.datosCotizacion.multicotiza.f7 }, { f2: this.datosCotizacion.multicotiza.f4 }, { f3: this.datosCotizacion.multicotiza.f8 }, { f4: this.datosCotizacion.multicotiza.f9 }, { fc: 29 }] }).subscribe(
        result => {
          this.loader = false;
          if (result.length == 0) {
            this.snackBar.open("Ocurrió un problema durante el proceso.", "", { duration: 1000 });
            this.resetValores();
          } else {
            this.descripciones = result;
            this.datosCotizacion.multicotiza.f3 = '';
          }
        }, error => {
          this.loader = false;
          this.resetValores();
          console.error("Error: ", error);
        }
      );
    } catch (e) {
      this.loader = false;
      this.resetValores();
      console.error("Exception ex =>", e);
    }
  }

  /**
   * Captura el tipo de unidad en versión móvil
   * @param tipoUnidad
   * 0 -> Auto
   * 1 -> Pickup
   * 9 o 10 -> Moto
   */
  cambioVehiculo(tipoUnidad: number) {
    this.datosCotizacion.multicotiza.f8 = '';
    this.datosCotizacion.multicotiza.f9 = '';
    this.datosCotizacion.multicotiza.f3 = '';
    this.datosCotizacion.multicotiza.f7 = tipoUnidad;
    this.datosCotizacion.datosAuto.tipoUnidad = tipoUnidad;
    this.getMarcas();
  }

  verificaDescripcion(amis: string) {
    if (this.descripciones.filter(item => item.c1 == amis).length > 0) {
      this.datosCotizacion.datosAuto.descripcion = this.descripciones.filter(item => item.c1 == amis)[0].c2;
    } else {
      this.datosCotizacion.datosAuto.descripcion = '';
    }
  }

  verificaEdad() {
    if (this.edad == '' || parseInt(this.edad) <= 17) {
      this.edad = "18";
    }
  }

  quitarPopup() {
    this.mostrarPopUp = false;
  }

  validarCorreo(){
    try{
      if(this.correo.value != '' && !this.correo.hasError('invalid')){
        this.requestService.getRequest({projectName: new Configuration().UTILERIAS_ENDPOINT_AES, apiName:'email-validation', params: [{email: this.correo.value}, {api_key: new Configuration().S4_KEY}]})
      .subscribe(
        result => {
          if(result.error){
            console.error("Exception ex =>", result.error);
          }else{
            if(!result.isValid){
              this.correo.setValue('*Ingrese un correo valido');
              this.correoValido = false;
            }else{
              this.correoValido = true;
            }
          }
        }
      );
      }

      if(this.correo.hasError('invalid')) {
        this.correo.setValue('*Ingrese un correo valido');
        this.correoValido = false;
      }
    }catch(error){
      console.error("Exception ex =>", error);
    }
  }

  limiteLetras(event: KeyboardEvent, limiteLetras: number) {

    InicioComponent.keyPressSoloLetras(event);
    InicioComponent.keyPressBloqueaCaracteres(event);
    if((<HTMLInputElement>event.target).value.length >= limiteLetras) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value =
      (<HTMLInputElement>event.target).value;
    }

  }


  static keyPressBloqueaCaracteres(event: KeyboardEvent) {
    if(
      event?.key == '!' ||
      event?.key == '"' ||
      event?.key == "#" ||
      event?.key == "$" ||
      event?.key == "%" ||
      event?.key == "&" ||
      event?.key == "/" ||
      event?.key == "(" ||
      event?.key == ")" ||
      event?.key == "=" ||
      event?.key == "?" ||
      event?.key == "¿" ||
      event?.key == "´" ||
      event?.key == "+" ||
      event?.key == "[" ||
      event?.key == "]" ||
      event?.key == "-" ||
      event?.keyCode == 33 ||
      event?.keyCode == 34 ||
      event?.keyCode == 35 ||
      event?.keyCode == 36 ||
      event?.keyCode == 37 ||
      event?.keyCode == 38 ||
      event?.keyCode == 37 ||
      event?.keyCode == 38 ||
      event?.keyCode == 47 ||
      event?.keyCode == 40 ||
      event?.keyCode == 41 ||
      event?.keyCode == 61 ||
      event?.keyCode == 63 ||
      event?.keyCode == 161 ||
      event?.keyCode == 42 ||
      event?.keyCode == 168 ||
      event?.keyCode == 123 ||
      event?.keyCode == 125
    ) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value =
      (<HTMLInputElement>event.target).value;
    }
  }


  static keyPressSoloLetras(event: KeyboardEvent) {

    this.keyPressSinEspacios(event);
    if (
      event?.key == '0' ||
      event?.key == '1' ||
      event?.key == '2' ||
      event?.key == '3' ||
      event?.key == '4' ||
      event?.key == '5' ||
      event?.key == '6' ||
      event?.key == '7' ||
      event?.key == '8' ||
      event?.key == '9' ||
      event?.keyCode == 48 ||
      event?.keyCode == 49 ||
      event?.keyCode == 50 ||
      event?.keyCode == 51 ||
      event?.keyCode == 52 ||
      event?.keyCode == 53 ||
      event?.keyCode == 54 ||
      event?.keyCode == 55 ||
      event?.keyCode == 56 ||
      event?.keyCode == 57
    ) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value =
          (<HTMLInputElement>event.target).value;
    }
  }
  static keyPressSinEspacios(event: KeyboardEvent) {
    if (event?.keyCode == 32) {
      event.preventDefault();
      } else {
      (<HTMLInputElement>event.target).value =
      (<HTMLInputElement>event.target).value;
      }
  }


  validPhoneNumber() {
     let cont = 1;
     let a = this.celular.charAt(0);
    let b = this.celular.charAt(1);

    while(a === b && cont < this.celular.length) {
      cont++;
      a = b;
      b = this.celular[cont];
    }

    if(cont === this.celular.length || this.celular.length < 10) {
      this.celular = '*Ingrese un numero valido';
      this.numeroValido = false;
    } else {
      this.numeroValido = true;
    }

  }
  navegador(){
    let isTrident = navigator.userAgent.indexOf('Trident/') > -1;
    return isTrident;
  }

  popup(){
    let popupExplorer = this.modal.open(this.popExplorer,{ disableClose: false});
  }

}
